import { atom } from "recoil";

const currentViewState = atom({
  key: "CurrentView",
  default: "locations",
});

const filterState = atom({
  key: "Filter",
  default: {},
});

const enabledResetButtonState = atom({
  key: "EnabledResetButton",
  default: false,
});

export { currentViewState, enabledResetButtonState, filterState };
